<ngx-sonner-toaster position="top-right" richColors closeButton [style]="{'--z-index': '9000'}" />
@if (oneLoginGuard.checking()) {
<app-pm-loading-overlay />
}
<router-outlet />
<pm-pinned-timer />
